import React, { Component } from 'react';
import RefreshIndicator from 'material-ui/RefreshIndicator';

class Loading extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: 'hide',
      style: { display: 'none', position: 'fixed', marginLeft:'50%' }
    }
    this.props.parent.loading = this;
  }

  showLoading() {
    this.setState({
      loading: 'loading',
      style: { display: 'inline-block', position: 'fixed', marginLeft:'50%' }
    })
  }

  closeLoading() {
    this.setState({
      loading: 'hide',
      style: { display: 'none', position: 'fixed', marginLeft:'50%' }
    })
  }

  render() {
    return (
      <RefreshIndicator
        size={50}
        left={-25}
        top={78}
        loadingColor="#FF9800"
        status={this.state.loading}
        style={this.state.style}
      />
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/Loading.js